import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '../../../../../app/translate';
import { InterpretationService } from '../../../../../app/modules/interpretation/interpretation.service';
import { InspectionTypeVM } from '../../../../../app/modules/rope-shovel/models/rope-shovel.model';
import { ComponentDetails, InspectionHistroyWornInfo, SystemDetails, SystemInspectionInfo } from '../../models/manage-equipment.model';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { LoadingService } from '../../../../../app/shared/services/loading.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';import { AppService } from '../../../../../app/app.service';
import { SetupEquipmentService } from '../../../../../app/modules/setup-equipment/setup-equipment.service';
import { InspectionNoteComponent } from '../inspection-note/inspection-note.component';
import { ViewPhotoComponent } from '../../../../../app/modules/rope-shovel/components/view-photo/view-photo.component';
import moment from 'moment';

@Component({
  selector: 'app-observationpoint-history',
  templateUrl: './observationpoint-history.component.html',
  styleUrls: ['./observationpoint-history.component.scss']
})
export class ObservationpointHistoryComponent implements OnInit {
  @Input() equipmentId: number;
  @Input() eqName: string;
  @Input() FamilyId:number;
  @Input() ModelId:number;

  checkedMeasurement:boolean=true;
  checkedWorn:boolean=true;
  checkedWeightedWorn:boolean=true;
  SelectedInspectionTypeId:number=-1;
  SelectedInspectionTypeId_:number[] = [-1];

  inspectionTypesList:InspectionTypeVM[];
  LeftSystem: ComponentDetails[];
  RightSystem: ComponentDetails[];
  equipmentSystems: SystemDetails[];
  inspectionsHistory:InspectionHistroyWornInfo[]=null;
  inspectionsHistoryCopy:InspectionHistroyWornInfo[]=null;


  LoadCount:number=6;
  Count:number =1;
  IsExapand:boolean=false;
  loading:boolean=false;
    constructor(private _interp: InterpretationService,
      
    private _titleService: Title, 
    private _translate: TranslateService,
    private _ref: ChangeDetectorRef, 
    private _equipmentService: ManageEquipmentService, 
    private _loading: LoadingService,
    private _app: AppService,
    private _setupService: SetupEquipmentService,private _dialog: MatDialog,
    private _sanitizer: DomSanitizer,
    private datePipe: DatePipe,) { }

  ngOnInit() {
    console.log("ModelId", this.ModelId)
    if(this.ModelId>0){
      this.loadInspectionTypes();
    }
    this.loadEquipmentSystems();
    
  }

  loadInspectionTypes(){

    this._interp.getInspectionTypes(this.ModelId).subscribe(res=>{
      this.inspectionTypesList = res;
    console.log("ModeinspectionTypesListlId", this.inspectionTypesList)

    })
}

InspectionTypeChange(){
  this.inspectionsHistory = this.inspectionsHistoryCopy;
  let arraynew = [];
  if(this.SelectedInspectionTypeId_.includes(-1)==false && this.SelectedInspectionTypeId_.length>0){

    this.inspectionsHistory.map(i=>{
      if(this.SelectedInspectionTypeId_.includes(i.InspectionTypeId)){
         arraynew.push(i);
      }
    })
    this.inspectionsHistory = arraynew;
  //this.inspectionsHistory = this.inspectionsHistory.filter(x=>x.InspectionTypeId == this.SelectedInspectionTypeId)

  }else if(this.SelectedInspectionTypeId_.length==0){
    this.inspectionsHistory = [];
  }

  if(this.inspectionsHistory!=null && this.inspectionsHistory.length>0){
    this.inspectionsHistory.map(x=>{
      x.LeftSide.map(y=>{
        y.isExpand=false;
      })
      x.RightSide.map(z=>{
        z.isExpand=false;
      })
    })
    this.LeftSystem.map(i=>{
      i.isExpand=false;
    })
    this.RightSystem.map(r=>{
      r.isExpand=false;
    })
  }
 
}
loadEquipmentSystems() {
     const today = new Date();
  this._equipmentService.getEquipmentSystems(this.equipmentId,moment(today).format('MM/DD/YYYY')).subscribe(systems => {
    this.equipmentSystems = systems;
    if (this.equipmentSystems != null) {
      this.LeftSystem = this.equipmentSystems[0].Components;
      this.RightSystem = this.equipmentSystems[2].Components;
      console.log("inspectionhistory", this.inspectionsHistory)
      this.equipmentSystems[1].Components.map(x => {
        this.LeftSystem.push(x);
      })
      this.equipmentSystems[3].Components.map(x => {
        this.RightSystem.push(x);
      })
      this.LoadGeneralInspectionsList();
    }
   // this.loadInspectionHistoryWorn();
 
  });



}

GetMeasurementPointsRecords(){

}
ExpandCompatyType(info:ComponentDetails,side:number){
  
  info.isExpand = !info.isExpand
  if(side==1){
    console.log("history", this.inspectionsHistory)
 this.inspectionsHistory.map((x,index)=>{
     x.LeftSide.map((y,lindex)=>{
       if(y.CompartTypeId ==info.CompartTypeId && y.Position == info.Position ){
        console.log("selected", info,y)
         y.isExpand = !y.isExpand
       }
     })
    })
  }
  if(side==2){
    console.log("history", this.inspectionsHistory)
 this.inspectionsHistory.map((x,index)=>{
     x.RightSide.map((y,lindex)=>{
       if(y.CompartTypeId ==info.CompartTypeId && y.Position == info.Position ){
        console.log("selected", info,y)
         y.isExpand = !y.isExpand
       }
     })
    })
  }

}

LoadGeneralInspectionsList(){
  this._equipmentService.getEquipmentGeneralInspectionsForHistoryLoadCountRSH(this.equipmentId,this.LoadCount).subscribe(inspections => {
    this.inspectionsHistory = inspections;
this.inspectionsHistoryCopy = inspections;
    console.log(" this.inspectionsHistoryWornNew________", this.inspectionsHistory)
    if(this.inspectionsHistory!=null){
      this.inspectionsHistory[0].LeftSide.map(x=>{
        this.LeftSystem.map(y=>{
        if(x.CompartTypeId ==y.CompartTypeId && x.Position==y.Position){
          y.MPRecords = x.MPRecords;
        }
        })
      })

      this.inspectionsHistory[0].RightSide.map(x=>{
        this.RightSystem.map(y=>{
        if(x.CompartTypeId ==y.CompartTypeId && x.Position==y.Position){
          y.MPRecords = x.MPRecords;
        }
        })
      })
     
    }
    this.loading=false;
  });
}
OpenInspectionComment(data:any) {
  const inspectionNote = this._dialog.open(InspectionNoteComponent, {
      panelClass: 'removeModalOverflow',
      data: {
          familyId: this.FamilyId,
          comment:(this.FamilyId==177 || this.FamilyId==203)?data.RspNote:data.generalComment,
          Interpcomment:data.Interpcomment,
      }
  });

  inspectionNote.afterClosed().subscribe(changeReadingUnit => {
      
  });

}

showPosition(position: number, compartTypeId: number): string {
  return this._app.getPositionString(position, compartTypeId);
}

LoadMore(){
  this.loading=true;
  this.Count = this.Count+1;
  this.LoadCount = this.LoadCount*this.Count;
  this.LoadGeneralInspectionsList();
  
}




getImage(image: string) {
  return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}

viewPhoto(img:string) {
  let viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    data: { photoType: 'measurementpoint_Img', photoId:null, img: img }
  });
  viewPhotoModalRef.afterClosed().subscribe(r => {
      
  });
}
}
